import { Component, Input, OnInit, OnDestroy } from '@angular/core'
import { Comment } from '@parkupp/core'
import { CommentService } from '../../../services/comment.service'
import { Subscription } from 'rxjs'

@Component({
    selector: 'app-comments',
    templateUrl: './comments.component.html',
    styleUrls: ['./comments.component.scss'],
})
export class CommentsComponent implements OnInit, OnDestroy {
    @Input() adminClientKey: string

    comments: Comment[] = []
    newCommentText: string = ''
    isLoading: boolean = true
    isSubmitting: boolean = false
    private subscription: Subscription

    constructor(private commentService: CommentService) {}

    ngOnInit(): void {
        if (this.adminClientKey) {
            this.loadComments()
        }
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe()
        }
    }

    // Return comments sorted by most recent first
    get sortedComments(): Comment[] {
        return [...this.comments].sort((a, b) => {
            const dateA = a.createdAt?.toDate ? a.createdAt.toDate() : new Date(a.createdAt as any)
            const dateB = b.createdAt?.toDate ? b.createdAt.toDate() : new Date(b.createdAt as any)
            return dateB.getTime() - dateA.getTime()
        })
    }

    loadComments(): void {
        this.isLoading = true
        this.subscription = this.commentService.listRealtime(this.adminClientKey).subscribe({
            next: (comments) => {
                this.comments = comments
                this.isLoading = false
            },
            error: (err) => {
                console.error('Error loading comments:', err)
                this.isLoading = false
            },
        })
    }

    async submitComment(): Promise<void> {
        if (!this.newCommentText.trim() || this.isSubmitting) {
            return
        }

        this.isSubmitting = true
        try {
            await this.commentService.add(this.adminClientKey, this.newCommentText.trim())
            this.newCommentText = ''
        } catch (error) {
            console.error('Error adding comment:', error)
        } finally {
            this.isSubmitting = false
        }
    }

    async deleteComment(comment: Comment): Promise<void> {
        if (!comment.$key || !confirm('Are you sure you want to delete this comment?')) {
            return
        }

        try {
            await this.commentService.delete(this.adminClientKey, comment.$key)
        } catch (error) {
            console.error('Error deleting comment:', error)
        }
    }

    onKeyDown(event: KeyboardEvent): void {
        // Submit on Enter (without Shift)
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault()
            this.submitComment()
        }
    }

    isSystemComment(comment: Comment): boolean {
        return comment.createdBy === 'system@parkupp.co.za'
    }

    formatDate(timestamp: any): string {
        if (!timestamp) return ''
        const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp)
        return date.toLocaleDateString('en-ZA', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        })
    }

}

